import { render, staticRenderFns } from "./ProjectFilesTable.vue?vue&type=template&id=2982dfd6"
import script from "./ProjectFilesTable.vue?vue&type=script&lang=js"
export * from "./ProjectFilesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports